module.exports = __webpack_public_path__ + "img/typing.f4ab339d.gif";